<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Dates from "../../../mixins/Dates";

import axios from 'axios';

/**
 * View ticket templates component
 */
export default {
  page: {
    title: "All Reports",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms, Dates],
  components: {Layout, PageHeader, Loader},
  data() {
    return {
      title: "All Reports",
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "All Reports",
          active: true
        }
      ],

      isLoading: false,
      reports: null,
      serverErrors: []
    };
  },
  methods: {
    loadReports() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/reports/').then(r => {
        vm.isLoading = false;
        vm.reports = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }
  },
  created() {
    this.loadReports();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="isLoading" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!isLoading" class="table-responsive mb-0">
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
<!--                  <th>Description</th>-->
                  <th>Created At</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="report in reports">
                  <th scope="row">{{ report.id }}</th>
                  <td>{{ report.name }}</td>
<!--                  <td>{{ report.description }}</td>-->
                  <td>{{ formatDate(report.created_at) }}</td>
                  <td class="text-right">
                    <!-- Button trigger modal -->
                    <button
                        type="button"
                        class="btn btn-itg btn-sm"
                        @click="$router.push('/reporting/'+report.id)"
                    >
                      Run Report
                    </button>
                  </td>
                </tr>
                <tr v-if="reports.length === 0">
                  <th scope="row" colspan="5">
                    <span class="text-danger">No results</span>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

        <a href="#" class="btn btn-itg-dark"
           @click.prevent="$router.push('/reporting/create')">Create
          Report
        </a>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
